import Vue from "vue"
import App from "./App.vue"
import NavBarAudit from "./components/NavBarAudit.vue"
import NavBarCo2 from "./components/NavBarCo2.vue"
import NavBarAuditOnsite from "./components/NavBarAuditOnsite.vue"
import NavBarAuditFlowDown from "./components/NavBarAuditFlowDown.vue"
import NavBarSustainability from "./components/NavBarSustainability.vue"
import NavBarTrace from "./components/NavBarTrace.vue"
import NavBarRisk from "./components/NavBarRisk.vue"
import NavBar from "./components/NavBar.vue"
import NavBarPortal from "./components/NavBarPortal.vue"
import NavBarConnections from "./components/NavBarConnections"
import NavBarSupplierPerformance from "./components/NavBarSupplierPerformance.vue"
import NavBarNis from "./components/NavBarNis.vue"
import ErrorDialog from "./components/ErrorDialog.vue"
import ResultsDialog from "./components/ResultsDialog.vue"
import SSCLoader from "./components/SSCLoader.vue"
import TemplateEditor from "./components/TemplateEditor.vue"
import OnsiteTemplateEditor from "./components/OnsiteTemplateEditor.vue"
import FlowDownTemplateEditor from "./components/FlowDownTemplateEditor.vue"
import TestError from "./components/TestError.vue"
import NotificationsList from "./components/NotificationsList.vue"
import router from "./router"
import vuetify from "./plugins/vuetify"
import axios from "axios"
import Vuex from "vuex"
import store from "./store"
import Breadcrumbs from "./components/Breadcrumbs.vue"
import {accessToOperation, accessToRoute} from "./plugins/authorized"
import getEnv from "./utils/env"
import SupplierCSR from "./components/SupplierCSR.vue"
import Footer from "./components/Footer.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons"
import SustainabilityPage from "./views/SustainabilityPage.vue"

library.add(faEnvelope,faPhone)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$accessToOperation = accessToOperation
Vue.prototype.$accessToRoute = accessToRoute
Vue.prototype.$APIURL = getEnv("VUE_APP_API_BASE_URL")

Vue.component("nav-bar", NavBar)
Vue.component("nav-bar-audit", NavBarAudit)
Vue.component("nav-bar-emissions", NavBarCo2)
Vue.component("nav-bar-auditonsite", NavBarAuditOnsite)
Vue.component("nav-bar-auditflowdown", NavBarAuditFlowDown)
Vue.component("nav-bar-sustainability", NavBarSustainability)
Vue.component("nav-bar-risk", NavBarRisk)
Vue.component("nav-bar-portal", NavBarPortal)
Vue.component("nav-bar-connections", NavBarConnections)
Vue.component("nav-bar-supplier-performance", NavBarSupplierPerformance)
Vue.component("nav-bar-nis", NavBarNis)
Vue.component("nav-bar-trace", NavBarTrace)
Vue.component("error-dialog", ErrorDialog)
Vue.component("results-dialog", ResultsDialog)
Vue.component("ssc-loader", SSCLoader)
Vue.component("template-editor", TemplateEditor)
Vue.component("flowdowntemplate-editor", FlowDownTemplateEditor)
Vue.component("onsitetemplate-editor", OnsiteTemplateEditor)
Vue.component("test-error", TestError)
Vue.component("breadcrumbs", Breadcrumbs)
Vue.component("notifications", NotificationsList)
Vue.component("supplier-csr", SupplierCSR)
Vue.component("orixe-footer", Footer)
Vue.component("sustainability-page", SustainabilityPage)
Vue.component("font-awesome-icon", FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(require("vue-moment"))

Vue.use(Vuex)
new Vue({
	el: "#app",
	components: { App },
	template: "<App/>",
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount("#app")
